export default {
    accesos: [
        { route: 'dashboard', modulo: '' },
        
        { route: 'disenio', modulo: '' },
        { route: 'disenio/dashboard', modulo: '' },
        { route: '', modulo: 'DisenioDashboardUsuario' },
        { route: 'disenio/briefs', modulo: '' },
        // { route: 'disenio/briefs/add', modulo: '' },
        // { route: 'disenio/briefs/:id/edit', modulo: '' },
        { route: 'disenio/briefs/:id', modulo: '' },
        { route: '', modulo: 'BriefsAgregarEntrega' },
        { route: '', modulo: 'BriefsEliminarEntrega' },
        { route: '', modulo: 'BriefsEntregasValidacionTecnica' },
        { route: '', modulo: 'BriefsEntregasSolucionarSolicitudCambios' },
        { route: '', modulo: 'BriefsAsignacionUsuarios' },
        { route: '', modulo: 'BriefsCerrar' },
        
        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/add', modulo: '' },
        { route: 'proveedores/proveedores/:id/edit', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },

        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/tareas-estados', modulo: '' },
        { route: 'tablas/tareas-estados/add', modulo: '' },
        { route: 'tablas/tareas-estados/:id', modulo: '' },
        { route: 'tablas/tareas-estados/:id/edit', modulo: '' },
    ]
}
